import styled from 'styled-components';

export const Wrapper = styled.div`
  display: inline-flex;
  background-color: #fff;
  position: relative;
  cursor: pointer;
  width: 100%;
  border-bottom: 1px solid #000;
  border-right: 0px solid #000;
  border-left: 0px solid #000;

  @media (min-width: ${({ theme }) => theme.breakPoint.TABLET}) {
    border-right: 1px solid #232a2e;
    border-left: 1px solid #232a2e;
    border-bottom: 0px solid #000;
  }
`;

export const Content = styled.div`
  color: #434343;
  display: inline-flex;
  height: 80px;
  padding: 13px 22px;
  width: 125px;
  flex-direction: column;
`;

export const Label = styled.div`
  color: #000;
  font-size: 11px;
  font-weight: 400;
  display: inline-flex;
`;

export const Text = styled.div`
  color: #000;
  font-size: 17px;
  font-weight: 600;
  margin-top: 5px;
  display: inline-flex;
`;
